import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { A } from '@ember/array';

import DiscoverApi from 'mewe/api/discover-api';
import FunctionalUtils from 'mewe/shared/functional-utils';

class Interest {
  name;
  category;
  @tracked selected;
}

export default class MwInterestsPicker extends Component {
  @tracked interests = A();
  @tracked isLoading = true;

  constructor() {
    super(...arguments);
    this.fetchInterests();
  }

  get selectedInterests() {
    return this.interests.filter((interest) => interest.selected).map((interest) => interest.name);
  }

  get isSubmitDisabled() {
    return this.isLoading || !this.selectedInterests.length;
  }

  fetchInterests() {
    // currently we don't have other locales but we have to send this param
    const locale = 'en';

    DiscoverApi.getInterestsList(locale)
      .then((resp) => {
        resp.interests.forEach((item) => {
          const i = new Interest();
          i.name = item.name;
          i.category = item.category;
          i.selected = false;

          this.interests.pushObject(i);
        });

        // in FTUE flow there is no need to fetch selected interests, there aren't any yet
        if (this.args.isFtueFlow) {

          this.args.updateInterests(A());
          this.isLoading = false;

        } else {

          // for simplicity it's done after fetching interests list first to prevent race condition
          DiscoverApi.getSelectedInterests()
            .then((resp) => {
              resp?.interests.forEach((item) => {
                const el = this.interests.find((i) => i.name === item.name);
                if (el) el.selected = true;
              });

              this.args.updateInterests(this.selectedInterests);
              this.isLoading = false;
            })
            .catch(() => {
              FunctionalUtils.showDefaultErrorMessage();
            });
        }
      })
      .catch(() => {
        FunctionalUtils.showDefaultErrorMessage();
      });
  }

  @action
  toggleInterest(item) {
    item.selected = !item.selected;
    this.args.updateInterests(this.selectedInterests);
  }
}
